// src/features/counter/counterSlice.ts
import {createSlice} from '@reduxjs/toolkit';

export interface CounterState {
    value: number;
}

const initialState: CounterState = {
    value: 0,
};

export const counterSlice = createSlice({
    name: 'counter',
    initialState,
    reducers: {
        setAmount: (state, action) => {
            state.value = action.payload;
        },
    },
});

export const {setAmount} = counterSlice.actions;
export default counterSlice.reducer;
